import React, { useEffect, useCallback } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../util/windowUtils.ts";
import { BASE_WINDOW_WIDTH } from "../../paths/games/cardComponent.tsx";

interface GameOverScreenProps {
    won: boolean;
    visible: boolean;
}

export const GameOverScreen: React.FC<GameOverScreenProps> = ({
    won,
    visible,
}) => {
    const { width } = useWindowDimensions();
    const s = width / BASE_WINDOW_WIDTH;
    const navigate = useNavigate();

    const handleReturnHome = useCallback(() => {
        navigate("/home");
    }, [navigate]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Enter" && visible) {
                handleReturnHome();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [visible, handleReturnHome]);

    if (!visible) return null;

    const modalSize = {
        width: Math.max(400 * s, 320),
        padding: Math.max(40 * s, 24),
        gap: Math.max(24 * s, 16),
    };

    const fontSize = {
        result: Math.max(48 * s, 32),
        message: Math.max(20 * s, 16),
        button: Math.max(18 * s, 14),
    };

    const buttonSize = Math.max(56 * s, 48);

    const resultText = won ? "Victory!" : "Defeat";
    const resultColor = won ? "#22c55e" : "#ef4444";

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.85)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    width: `${modalSize.width}px`,
                    backgroundColor: "#1f2937",
                    borderRadius: `${16 * s}px`,
                    padding: `${modalSize.padding}px`,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: `${modalSize.gap}px`,
                    boxShadow: `0 ${12 * s}px ${48 * s}px rgba(0, 0, 0, 0.6)`,
                    border: `${2 * s}px solid ${resultColor}`,
                }}
            >
                <div
                    style={{
                        color: resultColor,
                        fontSize: `${fontSize.result}px`,
                        fontWeight: "bold",
                        textShadow: `0 ${4 * s}px ${8 * s}px rgba(0, 0, 0, 0.3)`,
                    }}
                >
                    {resultText}
                </div>

                <Button
                    variant={won ? "success" : "danger"}
                    onClick={handleReturnHome}
                    style={{
                        width: "100%",
                        height: `${buttonSize}px`,
                        fontSize: `${fontSize.button}px`,
                        marginTop: `${8 * s}px`,
                    }}
                >
                    Return to Home
                </Button>
            </div>
        </div>
    );
};